import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import { Route, BrowserRouter, Routes, Navigate, useParams } from 'react-router-dom';
import { DslpTab } from './components/TabViewSwitcher';

const baseUrl = '/:locale?/:category/:name/:fourfour';
const defaultTab = DslpTab.About;

const RedirectToTab: React.FC<{ targetTab: DslpTab }> = ({ targetTab }) => {
  const { locale, category, name, fourfour } = useParams();

  // Build the path with actual parameter values
  const pathParts = [locale, category, name, fourfour, targetTab].filter(Boolean);
  const redirectPath = `/${pathParts.join('/')}`;

  return <Navigate to={redirectPath} replace />;
};

const Root: React.FC<{ store: any }> = ({ store }) => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path={`${baseUrl}/${DslpTab.About}`} element={<App />} />
          <Route path={`${baseUrl}/${DslpTab.Data}`} element={<App />} />
          <Route path={`${baseUrl}/${DslpTab.RelatedContent}`} element={<App />} />

          <Route path={`${baseUrl}/about`} element={<RedirectToTab targetTab={DslpTab.About} />} />

          <Route path={`${baseUrl}/data`} element={<RedirectToTab targetTab={defaultTab} />} />
          <Route path={baseUrl} element={<RedirectToTab targetTab={defaultTab} />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default Root;
